<template>
    <div>
        <h1 class="text-gray-100">DPS Offset Calculator</h1>

        <div class="space-y-10 divide-y divide-gray-900/10">
            <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-2">
<!--                <div class="px-4 sm:px-0 max-w-xl">-->
<!--                    <h2 class="text-base font-semibold leading-7 text-gray-900">Current SoniShield View Reading</h2>-->
<!--                    <p class="mt-1 text-sm leading-6 text-gray-600">-->
<!--                        Reading in "WC"-->
<!--                    </p>-->
<!--                </div>-->

                <div    class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
                    <div class="grid grid-cols-1 md:grid-cols-2 px-4 py-6 sm:p-8">
                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <!-- SoniShield View DPS Reading -->
                            <div class="sm:col-span-4">
                                <label class="block text-sm font-medium leading-6 text-gray-900" for="website">
                                    Current SoniShield View Reading</label>
                                <div class="mt-2">
                                    <floating-input     v-model:value="dpsOffset.currentReading"
                                                        label="Reading in 'WC'"
                                                        @change="calculateNewOffset"
                                                        :class="[this.dpsOffset.errors.currentReading ? 'border border-red-500' : '']"
                                    ></floating-input>
                                </div>
                            </div>

                            <!-- Expected DPS Reading -->
                            <div class="sm:col-span-4">
                                <label class="block text-sm font-medium leading-6 text-gray-900" for="about">
                                    Expected SoniShield View DPS Reading</label>
                                <div class="mt-2">
                                    <floating-input     v-model:value="dpsOffset.expectedReading"
                                                        label="(This value comes from the customer)"
                                                        @change="calculateNewOffset"
                                                        :class="[this.dpsOffset.errors.expectedReading ? 'border border-red-500' : '']"
                                    ></floating-input>
                                </div>
                            </div>

                            <!-- Current Offset -->
                            <div class="sm:col-span-4">
                                <label class="block text-sm font-medium leading-6 text-gray-900" for="about">
                                    Current Offset</label>
                                <div class="mt-2">
                                    <floating-input     v-model:value="dpsOffset.currentOffset"
                                                        label="This value is from Config Parameters"
                                                        @change="calculateNewOffset"
                                                        :class="[this.dpsOffset.errors.currentOffset ? 'border border-red-500' : '']"
                                    ></floating-input>
                                </div>
                            </div>
                        </div>

                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <!-- True' Reading -->
                            <div class="sm:col-span-4">
                                <label class="block text-sm font-medium leading-6 text-gray-900" for="about">
                                    True Reading</label>
                                <div class="mt-2">
                                    <floating-input     v-model:value="dpsOffset.trueReading"
                                                        :readonly="true"
                                                        label="The actual value the DPS is reading."
                                    ></floating-input>
                                </div>
                            </div>

                            <!-- Delta -->
                            <div class="sm:col-span-4">
                                <label class="block text-sm font-medium leading-6 text-gray-900" for="about">
                                    Delta</label>
                                <div class="mt-2">
                                    <floating-input     v-model:value="dpsOffset.delta"
                                                        :readonly="true"
                                                        label="Difference between actual DPS reading & desire."
                                    ></floating-input>
                                </div>
                            </div>

                            <!-- New Offset -->
                            <div class="sm:col-span-4">
                                <label class="block text-sm font-medium leading-6 text-gray-900" for="about">
                                    New Offset</label>
                                <div class="flex flex-col mt-2">
                                    <span   v-if="invalidValuesExist"
                                            class="text-red-500">
                                        One or more values are invalid.
                                    </span>
                                    <floating-input     v-model:value="dpsOffset.newOffset"
                                                        :readonly="true"
                                                        label="Calculated New Offset"
                                    ></floating-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link.vue";
import FloatingInput from "@/components/elements/FloatingInput.vue";

export default {
    name: "DpsOffsetCalculator",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {FloatingInput},
    emits: [],
    props: {},
    data() {
        return {
            // Assume 1 level calculation for now.  (only 1 room)
            dpsOffset: {
                // Inputed values
                currentReading: 0,
                expectedReading: 0,
                currentOffset: 0,

                // Error Values
                errors : {
                    currentReading: false,
                    expectedReading: false,
                    currentOffset: false,
                },

                // Calculated Values
                trueReading: 0,
                delta: 0,
                newOffset: 0,
            }
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        calculateNewOffset() {
            if (! this.inputedValuesExist) {
                return;
            }
            // TODO.  Add Error Labeling
            let currentReading = parseFloat(this.dpsOffset.currentReading);
            let expectedReading = parseFloat(this.dpsOffset.expectedReading);
            let currentOffset = parseFloat(this.dpsOffset.currentOffset);

            this.dpsOffset.errors.currentReading = _.isNaN(currentReading)
            this.dpsOffset.errors.expectedReading = _.isNaN(expectedReading)
            this.dpsOffset.errors.currentOffset = _.isNaN(currentOffset)

            if (this.invalidValuesExist) {
                return;
            }

            // Calculate the offset
            this.dpsOffset.trueReading = currentReading + currentOffset
            this.dpsOffset.delta = this.dpsOffset.trueReading - expectedReading;
            this.dpsOffset.newOffset = this.dpsOffset.delta;
        },
    },
    computed: {
        inputedValuesExist() {
            return this.dpsOffset.currentReading !== ''
                && this.dpsOffset.expectedReading !== ''
                && this.dpsOffset.currentOffset !== '';
        },
        invalidValuesExist() {
            return this.dpsOffset.errors.currentReading
                || this.dpsOffset.errors.expectedReading
                || this.dpsOffset.errors.currentOffset;
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>